import { render, staticRenderFns } from "./SampleTable.vue?vue&type=template&id=37f94574&scoped=true&"
import script from "./SampleTable.vue?vue&type=script&lang=js&"
export * from "./SampleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f94574",
  null
  
)

export default component.exports